<mat-accordion class="mat-expansion-panel-help">
    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" [expanded]="false"
        (click)="generateTagIfOpen()">
        <mat-expansion-panel-header class="border">
            <div class="title"> {{"help."+titleBloc+".title" | translate}} </div>
        </mat-expansion-panel-header>
        <div [ngSwitch]="titleBloc" class="body_container">
            <div *ngSwitchCase="'claim'">
                <div>{{ "help.claim.question" | translate }}</div>
                <div>{{ "help.claim.text1" | translate }}</div>
                <ul>
                    <li>{{ "help.claim.bullets.0" | translate }}
                    <li>{{ "help.claim.bullets.1" | translate }}
                </ul>
                <div>{{ "help.claim.link1" | translate }} <a
                        href="https://aide.laposte.fr/contact/colissimo">https://aide.laposte.fr/contact/colissimo</a>
                </div>
                <div>{{ "help.claim.link2" | translate }} <a
                        href="https://reclamations.laposte.fr">https://reclamations.laposte.fr</a>
                </div>
            </div>
            <div *ngSwitchCase="'tracking'" class="body_container">
                <div>{{ "help.tracking.part1.text1" | translate }}</div>
                <ul>
                    <li>{{ "help.tracking.part1.bullets.0" | translate }}
                    <li>{{ "help.tracking.part1.bullets.1" | translate }}
                </ul>

                <div>{{ "help.tracking.part2.link1" | translate }}
                    <a href="https://www.laposte.fr/outils/suivre-vos-envois">https://www.laposte.fr/outils/suivre-vos-envois</a>
                </div>
                <div>{{ "help.tracking.part2.text1" | translate }}</div>
                <div class="question">{{ "help.tracking.part2.question" | translate }}</div>
                <div>{{ "help.tracking.part2.text2" | translate }}</div>
                <ul>
                    <li>{{ "help.tracking.part2.bullets.0" | translate }}
                    <li>{{ "help.tracking.part2.bullets.1" | translate }}
                    <li>{{ "help.tracking.part2.bullets.2" | translate }}
                </ul>

                <div class="question">{{ "help.tracking.part3.question" | translate }}</div>
                <ul>
                    <li>{{ "help.tracking.part3.bullets.0" | translate }}
                    <li>{{ "help.tracking.part3.bullets.1" | translate }}
                </ul>

                <div class="question">{{ "help.tracking.part4.question" | translate }}</div>
                <div>{{ "help.tracking.part4.text1" | translate }}</div>
                <ul>
                    <li>{{ "help.tracking.part4.bullets.0" | translate }}
                    <li>{{ "help.tracking.part4.bullets.1" | translate }}
                    <li>{{ "help.tracking.part4.bullets.2" | translate }}
                    <li>{{ "help.tracking.part4.bullets.3" | translate }}
                    <li>{{ "help.tracking.part4.bullets.4" | translate }}
                    <li>{{ "help.tracking.part4.bullets.5" | translate }}
                </ul>
            </div>
            <div *ngSwitchCase="'delivery-choice'" class="body_container">
                <div class="question">{{ "help.delivery-choice.question" | translate }}</div>
                <img src="assets/images/delivery_button.png">
                <div>{{ "help.delivery-choice.text1" | translate }}</div>
                <ul>
                    <li>{{ "help.delivery-choice.bullets.0" | translate }}
                    <li>{{ "help.delivery-choice.bullets.1" | translate }}
                </ul>
                <div>{{ "help.delivery-choice.text2" | translate }}</div>
            </div>
            <div *ngSwitchCase="'availability'" class="body_container">
                <div>{{ "help.availability.text1" | translate }}</div>
                <ul>
                    <li>{{ "help.availability.bullets.0" | translate }}
                    <li>{{ "help.availability.bullets.1" | translate }}
                </ul>
                <div>{{ "help.availability.link1" | translate }}
                    <a href="https://www.laposte.fr/moncompte-laposte-avantages">https://www.laposte.fr/moncompte-laposte-avantages</a></div>
            </div>
            <div *ngSwitchCase="'unavailability'" class="body_container">
                <div>{{ "help.unavailability.part1.text1" | translate }}</div>
                <ul>
                    <li>{{ "help.unavailability.part1.bullets.0" | translate }} <a href="https://aide.laposte.fr/contact/colissimo">https://aide.laposte.fr/contact/colissimo.</a>
                    <li>{{ "help.unavailability.part1.bullets.1" | translate }}
                </ul>
                <div>
                    <span class="trick">{{ "help.unavailability.part2.trick" | translate }}</span>
                    <span class="trick_message">{{ "help.unavailability.part2.text1" | translate }}</span>
                </div>
                <ul>
                    <li>{{ "help.unavailability.part3.bullets.0" | translate }}
                </ul>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>